import { useMutation, useQueryClient } from "@tanstack/react-query";
import adminApiClient from "api/admin";
import { STUDIO_CONTRACT_QUERY_KEY } from "./useStudioContract";

const useSaveStudioContract = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (html: string) => adminApiClient.saveStudioContract(html),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [STUDIO_CONTRACT_QUERY_KEY] });
    },
  });
};

export default useSaveStudioContract;
